import { render } from "./PointJournalierDesVentes.vue?vue&type=template&id=10d5e8e4&ts=true"
import script from "./PointJournalierDesVentes.vue?vue&type=script&lang=ts"
export * from "./PointJournalierDesVentes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__